import { DeleteButton } from "@/components/button/DeleteButton.tsx";
import { WModal, WModalContent, type WModalContentProps, type WModalProps } from "@/components/modal/WModal.tsx";
import { isTodoFn } from "@/dev/todoFn.ts";
import { useLingui } from "@lingui/react/macro";
import type { ComponentType } from "react";
import type { SetOptional } from "type-fest";

interface ModalButtonProps {
    isDisabled?: boolean;
    inTable?: boolean;
    isTodo?: boolean;
    /** The button does not need an action since `DialogTrigger` will handle it */
    action: undefined;
}

export interface ActionModalProps
    extends
        Omit<WModalProps, "button" | "children">,
        SetOptional<WModalContentProps, "title">,
        Partial<ModalButtonProps> {
    buttonComponent: ComponentType<ModalButtonProps>;
}

export function ActionModal({
    buttonComponent: ButtonComponent,
    isDisabled,
    inTable,
    isTodo,
    children,
    ...modalContentProps
}: ActionModalProps) {
    const { t } = useLingui();
    const { modalAction } = modalContentProps;
    return (
        <WModal
            button={
                <ButtonComponent
                    isDisabled={isDisabled}
                    inTable={inTable}
                    isTodo={isTodo ?? isTodoFn(modalAction)}
                    action={undefined}
                />
            }
        >
            <WModalContent title={t`Confirmation`} {...modalContentProps}>
                {children}
            </WModalContent>
        </WModal>
    );
}

export type DeleteModalProps = Omit<ActionModalProps, "buttonComponent" | "label" | "title">;

export function DeleteModal(props: DeleteModalProps) {
    const { t } = useLingui();
    return <ActionModal buttonComponent={DeleteButton} label={t`Delete`} {...props} />;
}
